export const bidderSettings = {
    adserverTargeting: [
        {
            key: 'hb_buyer_id',
            val(bidResponse) {
                // TODO: should we return null or an empty string?
                return bidResponse.appnexus?.buyerMemberId ?? '';
            },
        },
    ],
    bidCpmAdjustment: (bidCpm) => {
        return bidCpm * 1.05;
    },
};
